module.exports = __webpack_public_path__ + "static/img/son10_active.16e98f13.png";